import { render, staticRenderFns } from "./isResumingSimple.vue?vue&type=template&id=01216cf6&scoped=true"
import script from "./isResumingSimple.vue?vue&type=script&lang=js"
export * from "./isResumingSimple.vue?vue&type=script&lang=js"
import style0 from "./isResumingSimple.vue?vue&type=style&index=0&id=01216cf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01216cf6",
  null
  
)

export default component.exports